<template>
    <div>
        <app-tabela
            idTabela="tblMovimentacoes"
            :itens="contrato.movimentacoesMinimaContrato"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <btn-inserir
                        :contrato="contrato"
                        :unidadesDeMedida="unidadesDeMedida"
                        @obterMovimentacoesAtualizadas="obterMovimentacoes()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="prazo" slot-scope="data">
                <span> <i class="fa fa-calendar"></i> {{ $moment(data.dataInicial).format('DD/MM/YYYY') }} &nbsp; <i class="fa fa-calendar"></i> {{ $moment(data.dataFinal).format('DD/MM/YYYY') }}</span>
            </template>
            <template slot="movimentacaoMinima" slot-scope="data">
                <span>{{ data.quantidade }} <b-badge size="large">{{ descreverUnidadeMedida(data.unidadeMedida) }}</b-badge></span>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar
                    :contrato="contrato"
                    :movimentacaoMinimaId="data.movimentacaoMinimaId"
                    :unidadesDeMedida="unidadesDeMedida"
                    @obterMovimentacoesAtualizadas="obterMovimentacoes()"
                ></btn-atualizar>
                <btn-excluir
                    :movimentacao="data"
                    @obterMovimentacoesAtualizadas="obterMovimentacoes()"
                    ></btn-excluir>
                <btn-listar-parcelas
                    :movimentacao="data"
                    :codigoContrato="contrato.vcCodigoEstruturado"
                    @obterMovimentacoesAtualizadas="obterMovimentacoes()"
                ></btn-listar-parcelas>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import MovimentacoesMinimasServicos from './MovimentacoesMinimasServicos'
import BtnInserir from './BtnInserirMovimentacao'
import BtnAtualizar from './BtnAtualizarMovimentacao'
import BtnExcluir from './BtnExcluirMovimentacao'
import BtnListarParcelas from './BtnListarParcelas'


export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnExcluir,
        BtnListarParcelas,
    },
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'prazo',
                    label: 'Prazo',
                    sortable: true,
                },
                {
                    key: 'movimentacaoMinima',
                    label: 'Movimentação Mínima',
                    sortable: true,
                },
                {
                    key: 'observacao',
                    label: 'Observação',
                    sortable: true,
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            unidadesDeMedida: [ 
                { id: null, descricao: '-- Selecione uma opção --' }, 
                { id: 1, descricao: 'Container' }, 
                { id: 2, descricao: 'Cubagem' }, 
                { id: 3, descricao: 'Litro' }, 
                { id: 4, descricao: 'Quilo' }, 
                { id: 5, descricao: 'Tonelada' },
                { id: 6, descricao: 'Unidade' }, 
            ]
        }
    },
    methods: {
        obterMovimentacoes() {
            this.$store.dispatch('addRequest')

            MovimentacoesMinimasServicos.obterMovimentacoes(this.contrato.idContrato)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.contrato.movimentacoesMinimaContrato = response.data
                            this.$emit('atualizarMovimentacoes', response.data)
                        } else {
                            this.$toast.error(
                                'Erro ao obter as movimentações',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        descreverUnidadeMedida(id) {
            var unidade = this.unidadesDeMedida.find(item => item.id === id);
            return unidade.descricao
        }
    },
}
</script>
